import { render, staticRenderFns } from "./attendence.vue?vue&type=template&id=4606a254&"
import script from "./attendence.vue?vue&type=script&lang=js&"
export * from "./attendence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports